/** Area di ritaglio in pixel dell'immagine sorgente (output di react-easy-crop). */
export interface PixelCrop {
    x: number;
    y: number;
    width: number;
    height: number;
}

const createImage = (url: string): Promise<HTMLImageElement> =>
    new Promise((resolve, reject) => {
        const img = new Image();
        img.addEventListener('load', () => resolve(img));
        img.addEventListener('error', e => reject(e));
        img.src = url;
    });

/**
 * Disegna la porzione ritagliata dell'immagine su un canvas delle dimensioni
 * di output desiderate e restituisce un PNG come Blob, pronto per l'upload.
 */
export async function getCroppedBlob(
    imageSrc: string,
    crop: PixelCrop,
    outputWidth: number,
    outputHeight: number,
): Promise<Blob> {
    const image = await createImage(imageSrc);
    const canvas = document.createElement('canvas');
    canvas.width = outputWidth;
    canvas.height = outputHeight;
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('Canvas 2D context non disponibile');

    const scaleX = outputWidth / crop.width;
    const scaleY = outputHeight / crop.height;
    ctx.drawImage(
        image,
        0, 0, image.width, image.height,
        -crop.x * scaleX, -crop.y * scaleY,
        image.width * scaleX, image.height * scaleY,
    );

    return new Promise((resolve, reject) => {
        canvas.toBlob(
            blob => (blob ? resolve(blob) : reject(new Error('Generazione immagine fallita'))),
            'image/png', 0.92,
        );
    });
}

export const readFileAsDataURL = (file: File): Promise<string> =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = e => reject(e);
        reader.readAsDataURL(file);
    });
